import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {browserHistory} from 'react-router'
import {CloseX} from '../Components/CloseX'
import * as Request from '../tgccRequest'



const wrapperStyle: React.CSSProperties = {
    backgroundColor: 'white',
    padding: '5px 25px 25px 25px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily:'BarlowMedium'
}

const contentStyle: React.CSSProperties = {
    position: 'relative',
    padding: '20px',
    border: Tgcc.Styles.singleBorder,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: Tgcc.Styles.darkTextColor,
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100px',
}

class Props extends Tgcc.BaseProps {
    filename: string;
    fileUrl: string;
    removeItem?: (url: string) => void;
    proof: Tgcc.Proof;
}

const imgStyle: React.CSSProperties = {
    alignSelf: 'center',
    maxWidth: '70px',
    maxHeight: '80px',
}
declare var UploadRoot: string;
const endsWith = (str: string, suffix: string) => {
    return str.indexOf(suffix, str.length - suffix.length) != 1;
}


class _MajorAccountsFileCard extends React.Component<Props, any> {

    
    canDisplayFile = (name: string) => {
        if(!name)
            return false;
        var test = name.toString().toUpperCase();
        return endsWith(test, '.JPG') || endsWith(test, '.PNG') || endsWith(test, '.TIF') || endsWith(test, '.SVG');
    }
    showLargeImg = () => {
        var name = this.props.filename;
        var url = UploadRoot + '/' + this.props.fileUrl;
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload:{action: Tgcc.DialogAction.EnLargeUpload,payload:{src:this.getImageSource(name, url)}}});
    }
    getImageSource = (fname: string, url: string) => {
        if(this.canDisplayFile(fname))
            return url;

        var test = fname.toString().toUpperCase();
        if(endsWith(test, ".PSD"))
            return Tgcc.Styles.uploadImagePlaceholder.PSD;
        if(endsWith(test, ".PDF"))
            return Tgcc.Styles.uploadImagePlaceholder.PDF;
        if(endsWith(test, ".AI"))
            return Tgcc.Styles.uploadImagePlaceholder.AI;
    }
    
    render() {
        var name = this.props.filename;
        var url = UploadRoot + '/' + this.props.fileUrl;
        var url1 = this.props.fileUrl;
        var img = <img style={imgStyle} src={this.getImageSource(name, url)} />;

        return (
            <div style={wrapperStyle}>
                <div style={contentStyle}>
                    <CloseX closeAction={ () => this.props.removeItem(url1)} />
                    <div onClick={this.showLargeImg}>{img}</div>
                    <div>{name}</div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var MajorAccountsFileCard = connect(mapStateToProps)(_MajorAccountsFileCard);